import { useS4AMastheadContext } from '../../../S4AMastheadProvider';
import { useUserState } from '../../hooks/useUserState';
import { Wait } from '../../Wait';
import React, { useState } from 'react';
import { TopBar } from './TopBar';
import { FlyoutMenu } from './FlyoutMenu';
import { useScrollPosition } from '@n8tb1t/use-scroll-position';
import { useActiveSubmenuContext, useActiveSubmenu, } from '../../../ActiveSubmenu/ActiveSubmenuProvider';
import { SECONDS_OUT } from './FlyoutMenu/config';
import { useSubmenuItem } from '../../../ActiveSubmenu/useSubmenuItem';
export const SideFlyoutMenu = ({ forcedUserState }) => {
    var _a;
    const userState = useUserState(forcedUserState);
    const { language, mastheadData } = useS4AMastheadContext();
    const [isSideNavOpen, setIsSideNavOpen] = useState(false);
    const { activeSubmenu } = useActiveSubmenuContext();
    const { clearActiveSubmenuNoDelay } = useActiveSubmenu(activeSubmenu);
    const activeItem = useSubmenuItem(activeSubmenu);
    const [isScrollingUp, setIsScrollingUp] = useState(false);
    useScrollPosition(({ prevPos, currPos }) => {
        setIsScrollingUp(currPos.y > prevPos.y || currPos.y > -1);
    }, []);
    const headerEntry = mastheadData === null || mastheadData === void 0 ? void 0 : mastheadData.fields.header;
    if (userState === 'loading' || !mastheadData) {
        return React.createElement(Wait, null);
    }
    const closeMenu = () => {
        if (activeSubmenu) {
            setTimeout(clearActiveSubmenuNoDelay, (SECONDS_OUT + 0.1) * 1000);
        }
        setIsSideNavOpen(false);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(TopBar, { isMenuOpen: isSideNavOpen, openMenu: () => setIsSideNavOpen(true), closeMenu: closeMenu, isScrollingUp: isScrollingUp, onBack: clearActiveSubmenuNoDelay, label: isSideNavOpen && ((_a = activeItem === null || activeItem === void 0 ? void 0 : activeItem.fields) === null || _a === void 0 ? void 0 : _a.label) }),
        React.createElement(FlyoutMenu, { dir: language.dir, "aria-label": headerEntry.fields.sideMenuPopoverAriaLabel, open: isSideNavOpen, userState: userState, onNavigate: closeMenu })));
};
//# sourceMappingURL=index.js.map